export * from './lib/UiProductInfoVideo';
